import { AppTransComponents } from 'app/appTrans';
import { MprcConfirmDialog, MprcRequestErrorDialog, MprcRequestIndicator } from 'components';
import RequestErrorUtils from 'components/MprcRequestErrorReport';
import { useSnackbar } from 'notistack';
import { useCoreApi } from 'providers/CoreApiProvider';
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

////////////////////////////////////////////////////////////////////////////////

interface IProps {
    topicId: string;
    name: string;
    onClose: (success: boolean | null) => void;
}

////////////////////////////////////////////////////////////////////////////////

export const DeleteTopic: React.FC<IProps> = (props) => {

    const { topicId, name, onClose } = props;

    const api = useCoreApi();
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    const [loading, setLoading] = useState<boolean>(false);
    const [viewError, setViewError] = useState<any>(null);

    ///
    const deleteTopic = () => {

        setLoading(true);
        api.v1.topicManagement.deleteTopic({ topicId })
            .then(result => {
                if (result.data === true) {
                    enqueueSnackbar(t("Topic.List.DeleteSuccessMessage"), {
                        variant: "success"
                    });
                    onClose(true);
                } else {
                    enqueueSnackbar(t("Topic.List.DeleteErrorMessage"), {
                        variant: "error"
                    });
                }
            }).catch(e => {
                const errorMessage = RequestErrorUtils.findValidationMessage(e, "topicId", "TopicCannotDeleteByParentRef");
                if (errorMessage) enqueueSnackbar(errorMessage, { variant: "error" });
                else setViewError(e);
            })
            .finally(() => setLoading(false));

    };

    return <>

        <MprcRequestIndicator visible={loading} type={"post"} />
        <MprcRequestErrorDialog
            error={viewError}
            onClose={() => setViewError(undefined)}
        />

        <MprcConfirmDialog
            open
            severity="danger"
            message={
                <Trans
                    t={t}
                    i18nKey="Topic.List.ConfirmDeleteMessage"
                    values={{ name: name }}
                    components={AppTransComponents}
                />
            }
            onClose={
                (yes) => {
                    if (yes) {
                        deleteTopic();
                    } else {
                        onClose(false);
                    }
                }
            }
        />
    </>;
};
